<template>
  <div
    class="bg-white rounded-md shadow-xl divide-y divide-gray-200"
    data-cy="label-editor-container"
  >
    <div class="p-2 space-y-2">
      <div class="text-headline font-semibold text-base">
        {{ $t("COMMON.EDIT_COLUMN_NAME") }}
      </div>
      <lf-input
        :value="localLabel"
        no-margin
        name="label"
        :placeholder="$t('COMMON.NAME')"
        data-cy="label-editor-input"
        @change="localLabel = $event.target.value"
      />
    </div>
    <div class="p-4">
      <lf-button
        class="bg-primary w-full"
        data-cy="label-editor-save-button"
        @click="handleSave"
      >
        {{ $t("COMMON.SAVE") }}
      </lf-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import LfButton from "@/components/ui/buttons/LfButton.vue";
import LfInput from "@/components/ui/inputs/LfInput.vue";

const { label } = defineProps<{
  label: string;
}>();

const emit = defineEmits<{
  save: [string];
}>();

const localLabel = ref(label);

const handleSave = () => {
  emit("save", localLabel.value);
};
</script>
